import { useState } from 'react';
import { App } from '@back4app2/sdk';
import { DsButton } from '../ds';
import { RollbackIcon } from '../ds/icons';
import { canRollBack } from '../MyAppActions';
import RollbackDialog from './RollbackDialog';

/**
 * "Instant Rollback" on the Overview head, where Vercel puts it: the same
 * rollback as the Action menu's "Roll back to previous", one click from the
 * screen that shows what is live.
 *
 * Only while there is a deployment to roll back from, and for someone who
 * can deploy: `canRollBack`, the same rule the Action menu's item reads.
 */
const InstantRollbackButton = ({ app }: { app: App }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!canRollBack(app)) {
    return null;
  }

  return (
    <>
      <DsButton
        variant="outline"
        size="lg"
        ariaLabel="Instant rollback"
        onClick={() => setIsOpen(true)}
      >
        <RollbackIcon size={16} />
        <span className="hidden sm:inline">Instant rollback</span>
      </DsButton>
      <RollbackDialog appId={app.id} open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default InstantRollbackButton;
